import { render } from "./NotificationsContent.vue?vue&type=template&id=036d98af"
import script from "./NotificationsContent.vue?vue&type=script&lang=js"
export * from "./NotificationsContent.vue?vue&type=script&lang=js"

import "./NotificationsContent.vue?vue&type=style&index=0&id=036d98af&lang=scss"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__